<div
  class="filter-header"
  [ngClass]="{ blur: showReportConfig }"
  *ngIf="navigationComponent?.nActiveFilters && currentView != 'flagManager'">
  You currently have filters applied and can only see partial information
  <span
    *ngIf="currentView != 'gallery'"
    style="font-size: 0.8em; font-weight: bold; font-style: italic; margin-left: 10px">
    {{ noteText }}
  </span>
  <button class="btn btn-link" (click)="openFilters()">Edit filters</button>
  <button class="btn btn-link" (click)="navigationComponent?.clearFilters()">Clear all</button>
</div>

<div [ngClass]="{ blur: showReportConfig }">
  <app-inspection-review
    #review
    *ngIf="currentView == 'main'"
    [inspection]="inspection"
    [answers]="answers"
    [filters]="filters"
    [navigation]="navigation"
    (onPopupOpened)="onPopupOpened()"
    (onPopupClosed)="onPopupClosed()"
    (refreshAnswers)="refreshAnswers()">
  </app-inspection-review>

  <app-inspection-snapshot
    #snapshot
    *ngIf="currentView == 'snapshot'"
    [inspection]="inspection"
    [answers]="answers"
    [filters]="filters">
  </app-inspection-snapshot>

  <app-inspection-gallery
    #gallery
    *ngIf="currentView == 'gallery'"
    [inspection]="inspection"
    [answers]="answers"
    [filters]="filters"
    [navigationComponent]="navigationComponent"
    (onPopupOpened)="onPopupOpened()"
    (onPopupClosed)="onPopupClosed()">
  </app-inspection-gallery>

  <!-- <app-flag-manager
    #flagManager
    [ngStyle]="{ display: currentView == 'flagManager' ? 'block' : 'none' }"
    [inspection]="inspection"
    [answers]="answers"
    [filters]="filters"
    [navigation]="navigation"
    [existingLetters]="existingLetters"
    (refreshAnswers)="refreshAnswers()">
  </app-flag-manager> -->

  <app-flag-manager-new-design
    #flagManager
    [ngStyle]="{ display: currentView == 'flagManager' ? 'block' : 'none' }"
    [inspection]="inspection"
    [answers]="answers"
    [filters]="filters"
    [navigation]="navigation"
    [existingLetters]="existingLetters"
    (refreshAnswers)="refreshAnswers()">
  </app-flag-manager-new-design>

  <app-inspection-locations
    #locations
    *ngIf="currentView == 'locations'"
    [inspection]="inspection"
    [answers]="answers"
    [filters]="filters"
    [navigationComponent]="navigationComponent">
  </app-inspection-locations>
</div>

<app-review-navigation
  #navigation
  [inspection]="inspection"
  [answers]="answers"
  [currentView]="currentView"
  (action)="onNavAction($event)"
  [isRecLetterSend]="isRecLetterSend"
  (filterChange)="onFilterChange($event)">
</app-review-navigation>

<div class="report-config" *ngIf="showLetterConfig">
  <span class="close" (click)="showLetterConfig = false"></span>
  <span style="font-weight: 500; font-size: 1.5em; margin-left: 20px">Create Recommendation Letter</span>
  <div style="display: flex; flex-direction: column; height: calc(100% - 40px)" forScroll>
    <div class="cant-create-letter" *ngIf="!canCreateLetter">
      All flags/groups must be completed before a letter can be created.
    </div>

    <br />

    <div class="btn-group" dropdown style="width: fit-content" [isDisabled]="!canCreateLetter">
      <button
        [disabled]="!canCreateLetter"
        type="button"
        (click)="previewVersion()"
        class="aru btn btn-primary"
        style="margin-right: 2px">
        Preview
      </button>
      <button
        id="button-basic"
        type="button"
        [disabled]="!canCreateLetter"
        class="btn btn-primary aru dropdown-toggle btn-multiple"
        aria-controls="dropdown-basic">
        <div class="content" (click)="createVersion()">Create new Version</div>

        <div class="arrow" dropdownToggle>
          <i class="fa fa-chevron-down"></i>
        </div>
      </button>

      <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-basic">
        <li role="menuitem">
          <a class="dropdown-item" href="#" (click)="createNoIssueVersion(); $event.preventDefault()">
            Create no Issues version</a
          >
        </li>
      </ul>
    </div>

    <div *ngIf="existingLetters?.length" style="flex: 1">
      <p style="margin: 30px 0">
        The following letters have already been generated for this inspection. Choose a version below to download or
        generate a new one.
      </p>

      <p>Latest:</p>
      <div class="letter-container">
        <div>
          <div>
            <div style="font-weight: 500">
              {{ dateTimeAsString(existingLetters[0].createdAt) }}<br />
              Viewed {{ existingLetters[0].views || 0 }} time{{ existingLetters[0].views == 1 ? '' : 's' }}
              <ng-container *ngIf="existingLetters[0].data?.template == 'no-issues'">
                <span class="no-issues-tag">no issues</span>
              </ng-container>
            </div>
          </div>
          <div class="flex d-flex justify-content-end mb-2" style="flex: 1; text-align: center">
            <button type="button" (click)="openLatestLetter()" class="aru btn btn-primary">Open</button>
            <button
              type="button"
              *ngIf="canSend"
              class="btn btn-sm btn-outline-danger rounded-pill btm-wh mr-1"
              (click)="openSendEmail(existingLetters[0].id)">
              Send Email
            </button>
          </div>
        </div>
        <span class="cursor" *ngIf="existingLetters[0]?.sentEmail?.length > 0">
          Email Sent
          {{
            existingLetters[0].sentEmail[existingLetters[0].sentEmail.length - 1].sentDate | date: 'MM-dd-yyyy / HH:mm'
          }}
          <a
            (click)="
              $event.preventDefault();
              previewEmail(existingLetters[0].sentEmail[existingLetters[0].sentEmail.length - 1])
            "
            href="#"
            class="pe-auto"
            >(View Email)</a
          >
          <a
            (click)="
              $event.preventDefault();
              downloadEmail(existingLetters[0].sentEmail[existingLetters[0].sentEmail.length - 1])
            "
            href="#"
            class="pe-auto ml-1"
            >Download Email</a
          >
        </span>
        <input [value]="customerUrl" (click)="copy(customerUrl); $event.target.select()" readonly />
        <a
          *ngIf="
            existingLetters[0]?.sentEmail?.length &&
            existingLetters[0].sentEmail[existingLetters[0].sentEmail.length - 1].sg_message_id
          "
          class="pe-auto ml-1"
          [routerLink]="['/', 'inspection', 'emailEvent', 'list']"
          [queryParams]="{
            sg_message_id: existingLetters[0].sentEmail[existingLetters[0].sentEmail.length - 1].sg_message_id
          }"
          >View Email Events</a
        >
      </div>
      <hr />

      <ng-container *ngIf="existingLetters?.length > 1">
        <p>Older:</p>

        <ng-container *ngFor="let letter of existingLetters.slice(1)">
          <div class="letter-container">
            <div>
              <div>
                <div style="font-weight: 500">
                  {{ dateTimeAsString(letter.createdAt) }}<br />
                  Viewed {{ letter.views }} time{{ letter.views == 1 ? '' : 's' }}
                  <ng-container *ngIf="letter.data?.template == 'no-issues'">
                    <span class="no-issues-tag">no issues</span>
                  </ng-container>
                </div>
              </div>
              <div style="flex: 1; text-align: end">
                <button type="button" (click)="openLetter(letter)" class="aru btn btn-primary">Open</button>
              </div>
            </div>
          </div>
          <div class="email-container">
            <span class="cursor" *ngIf="letter.sentEmail && letter.sentEmail.length > 0">
              Email Sent
              {{ letter.sentEmail[letter.sentEmail.length - 1].sentDate | date: 'MM-dd-yyyy / HH:mm' }}
              <a
                (click)="$event.preventDefault(); previewEmail(letter.sentEmail[letter.sentEmail.length - 1])"
                href="#"
                class="pe-auto"
                >(View Email)</a
              >
              <a
                (click)="$event.preventDefault(); downloadEmail(letter.sentEmail[letter.sentEmail.length - 1])"
                href="#"
                class="pe-auto ml-1"
                >Download Email</a
              >
            </span>
          </div>
          <hr />
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>

<div class="report-config" *ngIf="showReportConfig">
  <span class="close" (click)="showReportConfig = false"></span>
  <span style="font-weight: 500; font-size: 1.5em; margin-left: 20px">Create output PDF report</span>

  <div *ngIf="!oldReportsDismissed" forScroll style="height: calc(100% - 40px)">
    <p style="margin: 30px 0">
      The following reports have already been generated for this inspection. Choose a version below to download or
      generate a new report.
    </p>

    <ng-container *ngFor="let report of existingReports">
      <div style="display: flex">
        <div style="flex: 1; text-align: center">
          <div style="font-weight: 500; margin-bottom: 15px">{{ dateTimeAsString(report.createdAt) }}</div>
          <button type="button" (click)="downloadReport(report)" class="aru btn btn-primary">Download</button>
        </div>
        <div>
          <ul style="list-style: none">
            <li>
              <i class="fa" [ngClass]="{ 'fa-check': report.showQuestions, 'fa-times': !report.showQuestions }"></i>
              Show Questions and Answers
            </li>
            <li>
              <i
                class="fa"
                [ngClass]="{ 'fa-check': report.showNonMandatory, 'fa-times': !report.showNonMandatory }"></i>
              Show non-mandatory
            </li>
            <li>
              <i class="fa" [ngClass]="{ 'fa-check': report.showFlags, 'fa-times': !report.showFlags }"></i>
              Show Flags
            </li>
            <li>
              <i
                class="fa"
                [ngClass]="{ 'fa-check': report.showAdminComments, 'fa-times': !report.showAdminComments }"></i>
              Show Admin Comments
            </li>
            <li>
              <i
                class="fa"
                [ngClass]="{
                  'fa-check': report.showInspectorComments,
                  'fa-times': !report.showInspectorComments
                }"></i>
              Show Inspector Comments
            </li>
            <li>
              <i class="fa" [ngClass]="{ 'fa-check': report.showLegacyIds, 'fa-times': !report.showLegacyIds }"></i>
              Show Legacy Ids
            </li>
            <li>
              <i
                class="fa"
                [ngClass]="{
                  'fa-check': report.showMarkupOverPictures,
                  'fa-times': !report.showMarkupOverPictures
                }"></i>
              Show markup/flags over pictures
            </li>
            <li>
              <i
                class="fa"
                [ngClass]="{
                  'fa-check': report.applyFilters,
                  'fa-times': !report.applyFilters
                }"></i>
              Apply filters
            </li>
          </ul>
        </div>
      </div>
      <hr />
    </ng-container>

    <button type="button" class="btn aru btn-primary" (click)="oldReportsDismissed = true">Create new report</button>
  </div>

  <div *ngIf="oldReportsDismissed">
    <br style="clear: both" />
    <br />

    <label style="float: left; margin: 0 10px 0px 0px" class="switch switch-pill switch-success"
      ><input [(ngModel)]="reportParams.showQuestions" class="switch-input" type="checkbox" /><span
        class="switch-slider"></span
    ></label>
    <span>Show Questions and Answers</span>

    <br style="clear: both" />
    <br />

    <label style="float: left; margin: 0 10px 0px 0px" class="switch switch-pill switch-success"
      ><input [(ngModel)]="reportParams.showNonMandatory" class="switch-input" type="checkbox" /><span
        class="switch-slider"></span
    ></label>
    <span>Show non-mandatory questions</span>

    <br style="clear: both" />
    <br />

    <label style="float: left; margin: 0 10px 0px 0px" class="switch switch-pill switch-success"
      ><input [(ngModel)]="reportParams.showAdminComments" class="switch-input" type="checkbox" /><span
        class="switch-slider"></span
    ></label>
    <span>Show admin comments</span>

    <br style="clear: both" />
    <br />

    <label style="float: left; margin: 0 10px 0px 0px" class="switch switch-pill switch-success"
      ><input [(ngModel)]="reportParams.showInspectorComments" class="switch-input" type="checkbox" /><span
        class="switch-slider"></span
    ></label>
    <span>Show inspector comments</span>

    <br style="clear: both" />
    <br />

    <label style="float: left; margin: 0 10px 0px 0px" class="switch switch-pill switch-success"
      ><input [(ngModel)]="reportParams.showFlags" class="switch-input" type="checkbox" /><span
        class="switch-slider"></span
    ></label>
    <span>Show flags</span>

    <br style="clear: both" />
    <br />

    <label style="float: left; margin: 0 10px 0px 0px" class="switch switch-pill switch-success"
      ><input [(ngModel)]="reportParams.showLegacyIds" class="switch-input" type="checkbox" /><span
        class="switch-slider"></span
    ></label>
    <span>Show Question Legacy IDs</span>

    <br style="clear: both" />
    <br />

    <label style="float: left; margin: 0 10px 0px 0px" class="switch switch-pill switch-success"
      ><input [(ngModel)]="reportParams.showMarkupOverPictures" class="switch-input" type="checkbox" /><span
        class="switch-slider"></span
    ></label>
    <span>Show markup/flags over pictures</span>

    <br style="clear: both" />
    <br />

    <label style="float: left; margin: 0 10px 0px 0px" class="switch switch-pill switch-success"
      ><input [(ngModel)]="reportParams.applyFilters" class="switch-input" type="checkbox" /><span
        class="switch-slider"></span
    ></label>
    <span>Apply filters</span>

    <br style="clear: both" />
    <br />

    <button type="button" class="btn aru btn-primary" (click)="createReport()">Create report</button>
  </div>
</div>

<svg version="1.1" xmlns="http://www.w3.org/2000/svg" class="blur-svg">
  <defs>
    <filter id="blur-filter">
      <feGaussianBlur stdDeviation="10"></feGaussianBlur>
    </filter>
  </defs>
</svg>

<app-send-email-modal
  #sendEmailModal
  [customerUrl]="customerUrl"
  (onSend)="handleEmailSent($event)"
  [letterId]="letterId"
  [productType]="inspection?.policy?.productType"
  [inspection]="inspection"></app-send-email-modal>

<app-create-version-modal
  #createVersionModal
  (create)="create($event)"
  [isPreviewLetter]="isPreviewLetter"
  (previewLetter)="previewLetter($event)"></app-create-version-modal>
